import React from "react";

import { TypeInsignia } from "@at/design-system-foundation";

import * as Styled from "./how-leasing-works-tabs.styled";
import { StepByStep } from "./panels/step-by-step";
import { WhatYouGet } from "./panels/what-you-get";

import { useChannel } from "../../../../../utils/hooks/use-channel";
import { useTracking } from "../../../../../utils/tracking/use-tracking";
import { TabsPattern } from "../../../../digital-retailing/advert/tabs/tabs-pattern";
import { TabHeadingType } from "../../../../digital-retailing/advert/tabs/tabs-pattern.type";
import { LeasingProductBordered } from "../../leasing-contract-customiser.styled";

export const HowLeasingWorksTabs = () => {
  const channel = useChannel();
  const { trackEvent } = useTracking();
  const tabHeadings: TabHeadingType[] = [
    {
      displayValue: "Step-by-step",
      callback: () => {
        trackEvent({ trackingLabel: `step-by-step-leasing-tabs-${channel}` });
      },
    },
    {
      displayValue: "What you get",
      callback: () => {
        trackEvent({ trackingLabel: `what-you-get-leasing-tabs-${channel}` });
      },
    },
  ];

  const panels = [
    <StepByStep key="step-by-step" />,
    <WhatYouGet key="what-you-get" />,
  ];

  return (
    <LeasingProductBordered className="hide-print">
      <TypeInsignia weight="400" as="h2">
        How leasing works
      </TypeInsignia>
      <Styled.LeasingTabsPattern>
        <TabsPattern
          activeTab={0}
          headings={tabHeadings}
          componentIdentifier="how-leasing-works-tabs"
        >
          {panels}
        </TabsPattern>
      </Styled.LeasingTabsPattern>
    </LeasingProductBordered>
  );
};
